export default {"src":"/_next/static/media/payment-ethereum-icon.31629b31.svg","height":20,"width":28};